import { SchoolModule } from '@/presentation/configuration/modules/SchoolModule'
import { LearningModule } from '@/presentation/configuration/modules/LearningModule'
import { UsersModule } from '@/presentation/configuration/modules/UsersModule'
import { DashboardModule } from '@/presentation/configuration/modules/DashboardModule'
import { ProfileModule } from '@/presentation/configuration/modules/ProfileModule.ts'
import { ReferentialModule } from '@/presentation/configuration/modules/ReferentialModule.ts'
import { ContentModule } from '@/presentation/configuration/modules/ContentModule.ts'
import { EMEthodosModule } from '@/presentation/configuration/modules/EMethodosModule.ts'
import { QuizModule } from '@/presentation/configuration/modules/QuizModule.ts'
import ExportsModule from '@/presentation/configuration/modules/ExportsModule.ts'

export default class Bootloader {
  public static initialize() {
    // Les services sont maintenant initialisés automatiquement via la factory

    const usersModule = new UsersModule()
    usersModule.initialize()

    // Register school repositories and use cases
    const schoolModule = new SchoolModule()
    schoolModule.initialize()

    // Register learning repositories and use cases
    const leaningModule = new LearningModule()
    leaningModule.initialize()

    // Register quiz repository and useCases
    const quizModule = new QuizModule()
    quizModule.initialize()

    // Register dashboard repositories and use cases
    const dashboardModule = new DashboardModule()
    dashboardModule.initialize()

    // Register profile repositories and use cases
    const profileModule = new ProfileModule()
    profileModule.initialize()

    // Register referential repositories and use cases
    const referentialModule = new ReferentialModule()
    referentialModule.initialize()

    // Register module using previous declared repositories for their use cases
    const contentModule = new ContentModule()
    contentModule.initialize()

    // Register eMethodos repositories and use cases
    const eMethodosModule = new EMEthodosModule()
    eMethodosModule.initialize()

    const exportsModule = new ExportsModule()
    exportsModule.initialize()
  }
}
